import React, {useEffect} from "react";
import {matchPath, Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes, routesLists} from "../../../core/models/static/routes/app-routes";
import PrintInvoiceView from "./invoice";
import ServerErrorView from "../error/server-error";
import AccessDeniedView from "../error/access-denied";
import PartSupportRequestPrintView from "./part-support-request";
import useAccessLevels from "../../hooks/use-access-levels";
import PrintOrderView from "./order";
import PrintCustomerOutstandingStatementView from "./customer-outstanding-statement";
import PrintPurchaseView from "./purchase";

const PrintViews = () => {
    const history = useHistory();
    const location = useLocation();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Redirect to 404 page if the base print route is accessed
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.print.base, exact: true})) {
            history.push(routes.error.notFound);
        }
    }, [location.pathname, history]);

    return (
        <>
            <Switch>
                <Route path={routes.print.base} exact/>
                {
                    operatorAccessLevels.packages.sales.invoiceInformation &&
                    operatorAccessLevels.packages.bizPrint.printInvoice &&
                    <Route path={routes.print.invoice} exact>
                        <PrintInvoiceView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.creditInformation &&
                    operatorAccessLevels.packages.bizPrint.printCredit &&
                    <Route path={routes.print.credit} exact>
                        <PrintInvoiceView credit/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.quoteInformation &&
                    operatorAccessLevels.packages.bizPrint.printQuote &&
                    <Route path={routes.print.quote} exact>
                        <PrintOrderView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.salesOrderInformation &&
                    operatorAccessLevels.packages.bizPrint.printSalesOrder &&
                    <Route path={routes.print.salesOrder} exact>
                        <PrintOrderView salesOrder/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.warrantyAndReturn.viewDetails &&
                    operatorAccessLevels.packages.bizPrint.printWarrantyAndReturnClaim &&
                    <Route path={routes.print.partSupport} exact>
                        <PartSupportRequestPrintView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.accountReceivables &&
                    operatorAccessLevels.packages.bizPrint.printCustomerOutstandingStatement &&
                    <Route path={routes.print.customerOutstandingStatement} exact>
                        <PrintCustomerOutstandingStatementView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.purchasing.viewPurchaseOrderDetails &&
                    operatorAccessLevels.packages.bizPrint.printPurchaseOrder &&
                    <Route path={routes.print.purchaseOrder} exact>
                        <PrintPurchaseView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.purchasing.viewPurchaseHistory &&
                    operatorAccessLevels.packages.bizPrint.printPurchaseHistory &&
                    <Route path={routes.print.purchaseHistory} exact>
                        <PrintPurchaseView history/>
                    </Route>
                }
                <Route path={routesLists.printWithServerErrorSection} exact>
                    <ServerErrorView root/>
                </Route>
                <Route path={routesLists.printWithAccessDeniedSection} exact>
                    <AccessDeniedView root/>
                </Route>
                <Redirect to={routes.error.notFound}/>
            </Switch>
        </>

    );
};

export default PrintViews;
